import React from 'react';
import { Progress, Tooltip } from 'antd';
import './CapacityIndicator.css';

interface CapacityIndicatorProps {
  capacity: number; // 0-100 percentage
  whiteText?: boolean; // For display on dark backgrounds
}

export const CapacityIndicator: React.FC<CapacityIndicatorProps> = ({ capacity, whiteText = false }) => {
  // Determine color based on capacity
  const getColor = (): string => {
    if (capacity < 70) return '#52c41a'; // Green - good
    if (capacity < 90) return '#faad14'; // Yellow - getting full
    if (capacity < 100) return '#fa8c16'; // Orange - almost full
    return '#ff4d4f'; // Red - at capacity
  };

  const getStatus = (): string => {
    if (capacity < 70) return 'Available';
    if (capacity < 90) return 'Busy';
    if (capacity < 100) return 'Nearly Full';
    return 'At Capacity';
  };

  return (
    <div className="capacity-indicator">
      <Tooltip title={`${capacity.toFixed(0)}% booked - ${getStatus()}`}>
        <Progress
          percent={capacity}
          strokeColor={whiteText ? 'white' : getColor()}
          size="small"
          showInfo={false}
          trailColor={whiteText ? 'rgba(255, 255, 255, 0.3)' : '#f0f0f0'}
        />
      </Tooltip>
      <div className="capacity-label">
        <span className="capacity-percentage" style={{ color: whiteText ? 'white' : '#262626' }}>
          {capacity.toFixed(0)}%
        </span>
        <span className="capacity-status" style={{ color: whiteText ? 'rgba(255, 255, 255, 0.9)' : getColor() }}>
          {getStatus()}
        </span>
      </div>
    </div>
  );
};
